import axios from "axios";
let pendingMap = new Map();
export let getPendingUrl = (config) => [config.method, config.url].join("&");

export class AxiosCanceler {
  /**
   * Add request
   * @param {Object} config
   */
  addPending(config) {
    this.removePending(config);
    let url = getPendingUrl(config);
    config.cancelToken =
      config.cancelToken ||
      new axios.CancelToken((cancel) => {
        if (!pendingMap.has(url)) {
          pendingMap.set(url, cancel);
        }
      });
  }
  // txt = {"营业执照","统一社会信用代码","扫描二维码登录","名称","注册资本","成立日期","法定代表人","经营范围","许可项目","住所","一般项目","登记机关" }

  /**
   * @description: Clear all pending
   */
  removeAllPending() {
    pendingMap.forEach((cancel) => {
      cancel && cancel();
    });
    pendingMap.clear();
  }

  /**
   * Removal request
   * @param {Object} config
   */
  removePending(config) {
    let url = getPendingUrl(config);

    if (pendingMap.has(url)) {
      let cancel = pendingMap.get(url);
      cancel && cancel(url);
      pendingMap.delete(url);
    }
  }

  /**
   * @description: reset
   */
  reset() {
    pendingMap = new Map();
  }
}

export let cancels = pendingMap;
